/**
 * Shared quantitative rules for the V5 market evidence graphic.
 *
 * The scale is the largest of the eight category values (2025 CVLs), not an
 * annual total: the four displayed categories do not sum exactly to either
 * year's total.
 */
export const MARKET_EVIDENCE_SCALE = 18525;

/** Max-relative ratio for one category value, clamped to 0..1. */
export function getMarketEvidenceRatio(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.min(1, Math.max(0, value / MARKET_EVIDENCE_SCALE));
}
